import { storageDateFormat } from '@/core';
import moment from 'moment';
export default function() {
	return {
		searchUUID: null, // Used to cancel old search
		orders: [],
		ordersLastUpdated: {},
		polledOrders: [],
		polledOrdersLastUpdated: {},
		ordersLoading: false,
		ordersFetching: false,
		ordersRefreshing: false,
		searchFilter: {
			dateType: 'etd',
			date: {
				from: moment().startOf('day')
					.subtract(7,'d')
					.format(storageDateFormat),
				to:''
			},
			searchAreas: [],
			fromDespatchParty: [],
			toDeliveryParty: [],
			customer: [],
			goodsTypes: [],
			orderTypes: [],
			economicalStatus: [],
			orderStatus: [],
			references: [],
			referencesText: '',
			planned: false,
			hasAtd: { value: undefined, label: 'showAny' },
			waybillNumber: [],
			mustHaveInboundEdi: false,
			inboundEdi: '',
			mustHaveDeviation: false,
		},
		loadedSearch: { id:-1, labelKey: 'resetSearch', },
		dateTypes: [
			'etd',
			'eta',
			'etx',
		],
		geocoding: false,
		totals: {
			orders: 0,
			volume: 0,
			weight: 0,
			loadingMeters: 0,
			totalPrice: 0,
			baseCurrency: 'NOK'
		},

		// Map related data

		lockMap: false,
		pollInterval: {},
		liveUpdateInProgress: false,
		selectedOriginalOrder: {},
		preloadedOrderData: []
	};
}
